<template>
  <div>
    <template>
      <v-data-table
          :headers="headers"
          :items="numberedItems"
          item-key="userID"
          :loading="loading"
          disable-pagination
          hide-default-footer
      >
        <template v-slot:[`item.status`]="{ item }">
          {{item.rejected ? "Rejected" : (item.approved ? "Approved" : "Pending")}}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" :disabled="loading">
                <v-icon color="black">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                  link
                  @click="invoice(item)"
              >
                <v-list-item-title> Download Invoice</v-list-item-title>
              </v-list-item>
              <v-list-item
                  link
                  @click="form(item)"
              >
                <v-list-item-title> Download Form</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </template>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box
        :show="messageShow"
        :message="message"
        :type="messageType"
        v-on:close-message="messageShow = !messageShow"
    ></message-box>
  </div>
</template>

<script>
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";

export default {
  name: "ChangeOfProgrammeHistory",
  components: {MessageBox, LoadingDialog},
  props: {
    items: Array
  },
  data: () => ({
    headers: [
      {
        text: "S/N",
        align: "start",
        value: "sno",
      },
      {text: "From", value: "currentProgramme.name"},
      {text: "To", value: "newProgramme.name"},
      {text: "Status", value: "status"},
      {text: "Actions", value: "actions", sortable: false},
    ],
    loading: false,
    messageType: "",
    message: "",
    messageShow: false,
  }),

  methods: {
    invoice(item){
      this.loading = true;
      Api.programmeChange.invoice(item.id)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'invoice.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => this.loading = false)
    },

    form(item){
      this.loading = true;
      Api.programmeChange.form(item.id)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'c_o_p_form.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => this.loading = false)
    },
  },

  computed: {
    numberedItems: function () {
      return this.items.map((e, index) => ({...e, sno: index + 1}))
    }
  }
}
</script>

<style scoped>

</style>
